import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { getFactoryLanguage } from "../../../../../redux/actions/Translation/googleTranslationAction";
import Form from "./Form";
import { useStyles } from './style';

export default function AddSupplier( { open, onClose } ) {
    const classes = useStyles();
    const [translations, setTranslations] = useState([]);
    const getTranslations = async () => {
        setTranslations(await getFactoryLanguage());
    }

    useEffect(() =>{
        getTranslations();
      },[])

    return (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth={"xs"}
        >
          <DialogTitle id="alert-dialog-title" className={classes.formTitle}>
            Add Suppiler
          </DialogTitle>
          <DialogContent>
            <Form
              translations={translations}
              onClose={onClose}
            />
          </DialogContent>
        </Dialog>
      )
}